module.exports = __webpack_public_path__ + "img/6.d7c6bd48.jpg";